import React, { useState, useEffect } from 'react';
import '../styles/Contas.css';

const logosBancos = {
  itau: '🏦',
  c6: '💳',
  nubank: '💜',
  stone: '🪨'
};

const nomeBancos = {
  itau: 'Itaú Personnalité',
  c6: 'C6 Bank',
  nubank: 'NuBank',
  stone: 'Stone Bank'
};

export default function Contas() {
  const [contas, setContas] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({
    nome: '',
    banco: 'itau',
    saldo: '',
    tipo: 'corrente'
  });

  useEffect(() => { carregarContas(); }, []);

  const carregarContas = async () => {
    const token = localStorage.getItem('token');
    try {
      const res = await fetch('/api/bank/contas', { headers: { 'Authorization': `Bearer ${token}` } });
      const data = await res.json();
      setContas(data.contas || []);
    } catch (error) { console.error('Erro:', error); }
  };

  const handleAddOuEditar = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');
    const url = editingId ? `/api/bank/contas/${editingId}` : '/api/bank/contas';
    const method = editingId ? 'PUT' : 'POST';

    try {
      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ ...formData, saldo: parseFloat(formData.saldo) })
      });
      const data = await res.json();
      if (data.success) {
        handleCancelar();
        carregarContas();
      }
    } catch (error) { console.error('Erro:', error); }
  };

  const handleEditar = (conta) => {
    setFormData({
      nome: conta.nome,
      banco: conta.banco,
      saldo: conta.saldo,
      tipo: conta.tipo
    });
    setEditingId(conta.id);
    setShowForm(true);
  };

  const handleDeletar = async (id) => {
    if (!window.confirm('Deletar conta?')) return;
    const token = localStorage.getItem('token');
    try {
      const res = await fetch(`/api/bank/contas/${id}`, { method: 'DELETE', headers: { 'Authorization': `Bearer ${token}` } });
      const data = await res.json();
      if (data.success) carregarContas();
    } catch (error) { console.error('Erro:', error); }
  };

  const handleCancelar = () => {
    setShowForm(false);
    setEditingId(null);
    setFormData({ nome: '', banco: 'itau', saldo: '', tipo: 'corrente' });
  };

  const saldoTotal = contas.reduce((sum, c) => sum + parseFloat(c.saldo || 0), 0);

  return (
    <div className="contas-page">
      <h1>🏦 Minhas Contas Bancárias</h1>

      <div className="saldo-total">
        <h2>Saldo Total</h2>
        <p>R$ {saldoTotal.toLocaleString('pt-BR', {minimumFractionDigits: 2})}</p>
      </div>

      <button className="btn-primary" onClick={() => setShowForm(!showForm)}>
        {showForm ? '✕ Cancelar' : '+ Adicionar Conta'}
      </button>

      {showForm && (
        <form onSubmit={handleAddOuEditar} className="form-card">
          <div className="form-group">
            <label>Nome da Conta</label>
            <input
              type="text"
              value={formData.nome}
              onChange={(e) => setFormData({...formData, nome: e.target.value})}
              placeholder="Ex: NuBank Rodrigo"
              required
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Banco</label>
              <select value={formData.banco} onChange={(e) => setFormData({...formData, banco: e.target.value})}>
                <option value="itau">Itaú Personnalité</option>
                <option value="c6">C6 Bank</option>
                <option value="nubank">NuBank</option>
                <option value="stone">Stone Bank</option>
              </select>
            </div>
            <div className="form-group">
              <label>Tipo</label>
              <select value={formData.tipo} onChange={(e) => setFormData({...formData, tipo: e.target.value})}>
                <option value="corrente">Corrente</option>
                <option value="poupanca">Poupança</option>
              </select>
            </div>
          </div>

          <div className="form-group">
            <label>Saldo Inicial (R$)</label>
            <input
              type="number"
              value={formData.saldo}
              onChange={(e) => setFormData({...formData, saldo: e.target.value})}
              step="0.01"
              required
            />
          </div>

          <div className="form-buttons">
            <button type="submit" className="btn-primary">{editingId ? 'Atualizar' : 'Adicionar'}</button>
            <button type="button" className="btn-secondary" onClick={handleCancelar}>Cancelar</button>
          </div>
        </form>
      )}

      <div className="contas-grid">
        {contas.map(conta => (
          <div key={conta.id} className="conta-card">
            <div className="conta-header">
              <span className="banco-logo">{logosBancos[conta.banco]}</span>
              <span className="banco-nome">{nomeBancos[conta.banco]}</span>
              <span className={`status ${conta.status}`}>{conta.status}</span>
            </div>

            <div className="conta-info">
              <h3>{conta.nome}</h3>
              <p className="tipo">{conta.tipo === 'corrente' ? 'Conta Corrente' : 'Poupança'}</p>
            </div>

            <div className="conta-saldo">
              <span>Saldo</span>
              <p>R$ {parseFloat(conta.saldo).toLocaleString('pt-BR', {minimumFractionDigits: 2})}</p>
            </div>

            <div className="conta-actions">
              <button className="btn-small" onClick={() => handleEditar(conta)}>✏️ Editar</button>
              <button className="btn-small danger" onClick={() => handleDeletar(conta.id)}>🗑️ Deletar</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
